import { Image } from "@nextui-org/react";
import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import leftArrow from "../../Assets/sidebar/arrows/left.svg";
import rightArrow from "../../Assets/sidebar/arrows/right.svg";
import blogIcon from "../../Assets/sidebar/event.png";
import { SidebarContext } from "Context/SidebarContext";
import { LoadingContext } from "Context/LoadingContext";

const Sidebar = () => {
  const icons = require.context("../../Assets/sidebar", true);
  const iconsList = icons.keys().map((image) => icons(image));
  
  // Import tab icons for children
  const tabIcons = require.context("../../Assets/tabs/non-active", true);
  const tabIconsList = tabIcons.keys().map((image) => tabIcons(image));
  
  const navigate = useNavigate();
  
  const sidebarData = [
    {
      title: "My fronds",
      link: "/my-fronds",
      icon: iconsList[0],
      isParent: true,
      children: [
        {
          title: "Create a frond",
          link: "/create-frond",
          icon: tabIconsList[0] || iconsList[0], // Using tab icon
        },
        {
          title: "Shared fronds",
          link: "/shared-fronds",
          icon: tabIconsList[1] || iconsList[0], // Using tab icon
        },
        {
          title: "Invitations",
          link: "/invitations",
          icon: tabIconsList[2] || iconsList[0], // Using tab icon
        },
        {
          title: "Archive",
          link: "/archived-fronds",
          icon: tabIconsList[3] || iconsList[0], // Using tab icon
        },
      ],
    },
    {
      title: "My Tasks",
      link: "/my-tasks",
      isParent: true,
      icon: iconsList[1],
      children: [
        {
          title: "All Tasks",
          link: "/my-tasks",
          icon: iconsList[1],
        },
        {
          title: "Archive",
          link: "/my-tasks/archive",
          icon: iconsList[1],
        }
      ]
    },
    {
      title: "Community",
      link: "/community",
      icon: iconsList[2],
    },
    {
      title: "Discover",
      link: "/discover",
      icon: iconsList[6],
    },
    {
      title: "Library",
      link: "/library",
      icon: iconsList[3],
    },
    {
      title: "Events",
      link: "/blogs",
      icon: blogIcon,
    },
    {
      title: "Contact Us",
      link: "/contact-us",
      icon: iconsList[5],
    },
  ];

  const { isSidebarLoaded, setIsidebarLoaded } = useContext(LoadingContext);

  useLayoutEffect(() => {
    if (!isSidebarLoaded) {
      setTimeout(() => {
        setIsidebarLoaded(true);
      }, 2000);
    }
  }, [isSidebarLoaded]);

  const { pathname } = useLocation();

  const formatPathname = (path) => {
    if (path === "/") return path;
    return path.replace(/\/+$/, "");
  };

  const formattedPathname = formatPathname(pathname);
  
  const isFrondsActive = formattedPathname === "/my-fronds";
  
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  const [showText, setShowText] = useState(false);
  const [isMyTasksOpen, setIsMyTasksOpen] = useState(false);
  const [isMyFrondsOpen, setIsMyFrondsOpen] = useState(false);

  const handleSidebarToggle = () => {
    setIsSideBarOpen(!isSideBarOpen);
    setIsOpen(!isOpen);
    if (isSideBarOpen) {
      setShowText(false);
    } else {
      setTimeout(() => {
        setShowText(true);
      }, 300);
    }
  };

  const { isOpen, setIsOpen } = useContext(SidebarContext);

  function closeSidebar() {
    if (window.innerWidth <= 767) {
      setIsSideBarOpen(false);
      setIsOpen(false);
      setShowText(false);
    }
  }

  useLayoutEffect(() => {
    closeSidebar();

    const handleResize = () => {
      closeSidebar();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isTaskActive = formattedPathname === "/my-tasks" || formattedPathname === "/my-tasks/archive";

  const isFrondsChildActive =
    formattedPathname === "/shared-fronds" ||
    formattedPathname === "/invitations" ||
    formattedPathname === "/archived-fronds" ||
    formattedPathname === "/create-frond";

  // Handle parent click - navigate to the parent route
  const handleParentClick = (item) => {
    navigate(item.link);
    if (window.innerWidth <= 767) {
      closeSidebar();
    }
  };

  // Handle chevron click - toggle dropdown
  const handleChevronClick = (e, item) => {
    e.stopPropagation();
    if (item.title === "My Tasks") {
      setIsMyTasksOpen(!isMyTasksOpen);
    }
    if (item.title === "My fronds") {
      setIsMyFrondsOpen(!isMyFrondsOpen);
    }
  };

  return (
    <aside
      className={`sidebar md:shadow-none shadow-goalsShadow bg-white md:px-[18px] px-[15px] md:py-[30px] py-2.5 md:min-h-[calc(100vh-104px)] min-h-[100vh] z-[99] md:fixed fixed md:left-auto md:top-[89px] md:bottom-auto left-0 bottom-0 top-[69px] ${
        isSideBarOpen
          ? "md:min-w-[218px] md:max-w-[218px] min-w-[189px] max-w-[189px]"
          : "md:min-w-[84px] md:max-w-[84px] min-w-[54px] max-w-[54px]"
      } transition-all duration-400 md:border-2 md:border-solid md:border-grayBorder md:rounded-4xl flex flex-col md:gap-4 gap-2.5 no-focus ${
        !isSidebarLoaded ? "opacity-0" : "opacity-100"
      }`}
    >
      <button
        onClick={handleSidebarToggle}
        className={`transition-all min-w-[24px] min-h-[24px] duration-600 absolute top-[12px] md:right-[-12px] right-[15px] bg-mainGradiant rounded-[5px] flex justify-center items-center`}
        style={{
          opacity: isSideBarOpen ? "1" : "0",
          visibility: isSideBarOpen ? "visible" : "hidden",
        }}
      >
        <Image src={leftArrow} alt="<" className="w[14px] h-[14px]" />
      </button>
      <button
        onClick={handleSidebarToggle}
        className={`transition-all min-w-[24px] min-h-[24px] duration-600 md:absolute top-[12px] right-[-12px] bg-mainGradiant rounded-[5px] flex justify-center items-center`}
        style={{
          opacity: !isSideBarOpen ? "1" : "0",
          visibility: !isSideBarOpen ? "visible" : "hidden",
        }}
      >
        <Image src={rightArrow} alt=">" className="w[14px] h-[14px]" />
      </button>
      
      {sidebarData.map((item, idx) => (
        <div key={idx}>
          {item.isParent ? (
            // Parent item (My Tasks with dropdown)
            <div className="flex flex-col">
              <div
                className={`flex gap-3 md:rounded-[10px] rounded-[5px] w-full items-center cursor-pointer ${
                  isSideBarOpen ? "px-3" : "md:px-2.5 px-[3px]"
                } md:py-2.5 py-[3px] ${
                  idx === 3
                    ? "relative after:absolute after:left-0 after:right-0 after:h-px after:bg-[#EDEAFF] after:bottom-[-15px]"
                    : ""
                } ${((item.title === "My Tasks" && isTaskActive) || (item.title === "My fronds" && (isFrondsActive || isFrondsChildActive))) ? "bg-[#F5F6FF]" : "bg-white"}`}
              >
                {/* Click on icon and title to navigate */}
                <div 
                  className="flex gap-3 items-center flex-1"
                  onClick={() => handleParentClick(item)}
                >
                  <Image
                    src={item.icon}
                    alt={item.title}
                    className="md:min-w-[24px] md:min-h-[24px] md:max-w-[24px] md:max-h-[24px] min-w-[18px] min-h-[18px] max-w-[18px] max-h-[18px]"
                  />
                  <h5
                    className={`text-textColor md:text-base text-xs whitespace-nowrap ${
                      (item.title === "My Tasks" && isTaskActive) || 
                      (item.title === "My fronds" && (isFrondsActive || isFrondsChildActive))
                        ? "font-bold" 
                        : "font-normal"
                    } ${!showText ? "hidden" : ""}`}
                  >
                    {item.title}
                  </h5>
                </div>
                
                {/* Chevron button - toggles dropdown */}
                {isSideBarOpen && showText && (
                  <button
                    className="ml-auto p-1 hover:bg-gray-100 rounded transition-colors"
                    onClick={(e) => handleChevronClick(e, item)}
                  >
                    <svg
                      className={`transition-transform duration-300 ${
                        (item.title === "My Tasks" && isMyTasksOpen) ||
                        (item.title === "My fronds" && isMyFrondsOpen)
                          ? "rotate-180"
                          : ""
                      }`}
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4 6L8 10L12 6"
                        stroke="#6B7280"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                )}
              </div>
              
              {/* Dropdown children */}
              {((item.title === "My Tasks" && isMyTasksOpen) || 
                (item.title === "My fronds" && isMyFrondsOpen)) && 
                isSideBarOpen && showText && (
                <div className="ml-8 mt-2 flex flex-col gap-2 relative after:absolute after:left-0 after:right-0 after:h-px after:bg-[#EDEAFF] after:bottom-[-12px]">
                  {item.children.map((child, childIdx) => (
                    <Link
                      key={childIdx}
                      to={child.link}
                      className="w-full tooltip-box"
                      onClick={() => {
                        if (window.innerWidth <= 767) {
                          closeSidebar();
                        }
                      }}
                    >
                      <div
                        className={`flex gap-3 md:rounded-[10px] rounded-[5px] w-full items-center px-3 md:py-2 py-[3px] ${
                          child.link === formattedPathname
                            ? "bg-[#F5F6FF] font-bold"
                            : "bg-white font-normal"
                        }`}
                      >
                        <Image
                          src={child.icon}
                          alt={child.title}
                          className="md:min-w-[20px] md:min-h-[20px] md:max-w-[20px] md:max-h-[20px] min-w-[16px] min-h-[16px] max-w-[16px] max-h-[16px]"
                        />
                        <h5 className="text-xs text-textColor md:text-sm whitespace-nowrap">
                          {child.title}
                        </h5>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ) : (
            // Regular menu items
            <div
              className={`${idx === 1 || idx === 3 ? "mb-[10px]" : ""} ${
                idx === 0 && isSideBarOpen ? "md:mt-0 mt-2.5" : ""
              } flex items-center relative`}
            >
              <Link 
                to={item.link} 
                className="w-full tooltip-box"
                onClick={() => {
                  if (window.innerWidth <= 767) {
                    closeSidebar();
                  }
                }}
              >
                <div
                  className={`flex gap-3 md:rounded-[10px] rounded-[5px] w-full items-center ${
                    isSideBarOpen ? "px-3" : "md:px-2.5 px-[3px]"
                  } md:py-2.5 py-[3px] ${
                    idx === 1 || idx === 3
                      ? "relative after:absolute after:left-0 after:right-0 after:h-px after:bg-[#EDEAFF] after:bottom-[-15px]"
                      : ""
                  } ${
                    item.link === formattedPathname ||
                    (item.link === "/" && formattedPathname === "/home") ||
                    (item.link === "/discover" &&
                      (formattedPathname === "/discover" || formattedPathname.startsWith("/discover/")))
                      ? "bg-[#F5F6FF]"
                      : "bg-white"
                  }`}
                >
                  <Image
                    src={item.icon}
                    alt={item.title}
                    className="md:min-w-[24px] md:min-h-[24px] md:max-w-[24px] md:max-h-[24px] min-w-[18px] min-h-[18px] max-w-[18px] max-h-[18px]"
                  />
                  <h5
                    className={`text-textColor md:text-base text-xs whitespace-nowrap ${
                      item.link === formattedPathname ||
                      (item.link === "/" && formattedPathname === "/home") ||
                      (item.link === "/discover" &&
                        (formattedPathname === "/discover" || formattedPathname.startsWith("/discover/")))
                        ? "font-bold"
                        : "font-normal"
                    } ${!showText ? "hidden" : ""}`}
                  >
                    {item.title}
                  </h5>
                </div>
              </Link>
              {!isOpen && (
                <div className="absolute right-[-110px] top-[55%] translate-y-[-50%] z-50 w-[110px] flex justify-center items-center bg-white rounded-2xl p-[5px] border-1 border-solid border-cardGrayColor transition-all duration-300 opacity-0 tooltip">
                  <span className="text-[13.5px] font-normal text-textColor">
                    {item.title}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </aside>
  );
};

export default Sidebar;
